module.exports = __webpack_public_path__ + "img/14.fc7a7540.jpg";